import { IConfig } from './views/interface';
let config: IConfig;

config = {
	API_ENDPOINT: 'https://partners.resi.uatz.view.com.au/exclusive-home/',
	DOMAIN: 'https://resi.uatz.view.com.au'
};

if (process.env.NODE_ENV === 'production') {
	config = {
		API_ENDPOINT: 'https://partners.view.com.au/exclusive-home/',
		DOMAIN: 'https://view.com.au'
	};
}

export default config;
